import * as questions from './actions';
import { ActionType, getType } from 'typesafe-actions';
import { QuestionsState } from './types';

const defaultState: QuestionsState = {
  loading: false,
  actionLoading: false,
  loadedQuestions: {},
  loadedAnswers: {},
  apiError: '',
};

export type QuestionActions = ActionType<typeof questions>

export default (state = defaultState, action: QuestionActions): QuestionsState => {
  switch (action.type) {
    case getType(questions.updateApiError):
      return {
        ...state,
        apiError: action.payload,
      }
    case getType(questions.addQuestionAction.success):
      return {
        ...state,
        actionLoading: false,
      }
    case getType(questions.addQuestionAction.failure):
      return {
        ...state,
        actionLoading: false,
        apiError: action.payload.message,
      }
    case getType(questions.addQuestionAction.request):
      return {
        ...state,
        actionLoading: true,
      }
    case getType(questions.getQuestionsAction.failure):
      return {
        ...state,
        loading: false,
      }
    case getType(questions.getQuestionsAction.request):
      return {
        ...state,
        loading: true,
      }
    case getType(questions.getQuestionsAction.success):
      return {
        ...state,
        loading: false,
        loadedQuestions: {
          ...action.payload,
          questions: action.payload.hasNextKey
            ? state.loadedQuestions.questions.concat(action.payload.questions)
            : action.payload.questions,
        },
      }
    case getType(questions.getAnswersAction.failure):
      return {
        ...state,
        loading: false,
      }
    case getType(questions.getAnswersAction.request):
      return {
        ...state,
        loading: true,
      }
    case getType(questions.getAnswersAction.success):
      return {
        ...state,
        loading: false,
        loadedAnswers: {
          ...action.payload,
          answers: action.payload.hasNextKey
            ? state.loadedAnswers.answers.concat(action.payload.answers)
            : action.payload.answers,
        },
      }
    case getType(questions.addAnswerAction.success):
      return {
        ...state,
        actionLoading: false,
      }
    case getType(questions.addAnswerAction.failure):
      return {
        ...state,
        actionLoading: false,
        apiError: action.payload.message,
      }
    case getType(questions.addAnswerAction.request):
      return {
        ...state,
        actionLoading: true,
      }
    default:
      return state;
  }
};
